 ;(function (pyatt, $, window, document, undefined) {

    pyatt.resizeVideo = {

        init : function() {

            $(document).on('ready', this.adjustVideoHeight);
            
            $(window).on('resize', Foundation.utils.throttle(this.adjustVideoHeight, 300));

        },

        adjustVideoHeight : function(i) {
            $('.banner-video').each(function() {
                var width = $(this).find('iframe').attr('width');
                var height = $(this).find('iframe').attr('height');
                width = typeof width === 'undefined' ? 640 : width;
                height = typeof height === 'undefined' ? 360 : height;

                var $container = $(this).closest('.container');
                var c_width = $container.innerWidth();
                if (typeof c_width === 'undefined') {
                    return;
                }
                var ratio = height / width;
                // var url = $(this).find('iframe').attr('src');
                
                // if (url.includes('vimeo')) {
                //     console.log("url", url);
                //     ratio = 0.5;
                // }

                var newHeight = ratio * c_width;

                $(this).css('margin', 0);
                $(this).css('padding', 0);
                $(this).css('height', newHeight);
                console.log("newHeight", newHeight);
            });

            $('.flex-video').each(function() {
                var width = $(this).find('iframe').attr('width');
                var height = $(this).find('iframe').attr('height');
                width = typeof width === 'undefined' ? 640 : width;
                height = typeof height === 'undefined' ? 360 : height;

                var $container = $(this).closest('#owl-featured');
                var c_width = $container.innerWidth();
                if (typeof c_width === 'undefined') {
                    return;
                }
                var ratio = height / width;
                // var url = $(this).find('iframe').attr('src');
                
                // if (url.includes('vimeo')) {
                //     console.log("url", url);
                //     ratio = 0.5;
                // }

                var newHeight = ratio * c_width;

               //$(this).css('margin', 0);
               // $(this).css('padding', 0);
                $(this).css('height', newHeight);
                console.log("newHeight", newHeight);
            });
        }

    };

}(window.pyatt = window.pyatt || {}, jQuery, window, window.document));
